"use client";

import React from "react";
import { Smartphone, BatteryCharging, Droplet, Activity, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Mehanički popravci",
  description: "Profesionalni popravak kočnica, upravljačkog mehanizma i svih mehaničkih komponenti vašeg romobila.",
  icon: Smartphone,
  highlight: false,
  link: "/ServicesPage"
}, {
  title: "Elektronika i BMS",
  description: "Precizna dijagnostika kontrolera i BMS sustava uz korištenje najmodernije mjerne opreme.",
  icon: Activity,
  highlight: false,
  link: "/ServicesPage"
}, {
  title: "Gume i zračnice",
  description: "Brza zamjena guma i zračnica svih dimenzija uz ugradnju otpornijih i kvalitetnijih materijala.",
  icon: Droplet,
  highlight: false,
  link: "/ServicesPage"
}, {
  title: "Servis baterija",
  description: "Obnova paketa, zamjena ćelija i testiranje kapaciteta za maksimalni doseg vašeg ljubimca.",
  icon: BatteryCharging,
  highlight: true,
  link: "/BatteryServicePage"
}];
export default function OurExpertRepairServices() {
  const {
    headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221992" id="naše-usluge" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-6 max-w-5xl relative z-10">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4 tracking-tight">
            Naše stručne usluge servisa
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Vrhunska preciznost i tehnička stručnost. ChargeZone vraća vaše električne romobile u savršeno vozno stanje.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.title} data-index={i} className={`group relative overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:border-t-2 hover:border-t-primary ${service.highlight ? "border-primary/40 shadow-lg shadow-primary/10 bg-card/95 backdrop-blur-sm" : "border-border/50 bg-card hover:border-border"}`}>
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                <CardHeader className="pb-4 relative z-10">
                  <div className={`w-12 h-12 rounded-sm flex items-center justify-center mb-4 transition-all duration-300 group-hover:shadow-[0_0_15px_rgba(0,255,159,0.3)] ${service.highlight ? "bg-primary/10 text-primary" : "bg-muted text-foreground"}`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <CardTitle className="text-xl font-default font-bold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="relative z-10 flex flex-col justify-between h-[calc(100%-100px)]">
                  <CardDescription className="text-base text-muted-foreground line-clamp-2 mb-6">
                    {service.description}
                  </CardDescription>
                  
                  <div className="mt-auto">
                    <Link to={service.link} className="inline-flex items-center text-sm font-semibold text-primary opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                      Saznaj više
                      <ChevronRight className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}